import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Row } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap'
import FeatherIcon from 'feather-icons-react';
import '../css/Header.css'
import '../css/horizontalmenu.css'


class ManageDriverSchedule extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Container>

<section id="number-tabs">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Manage Driver Schedule</h4>
              </div>
              <div className="card-content">
                <div className="card-body">
                  <form action="#" className="number-tab-steps wizard-circle">
                    {/* Step 1 */}
                    <h6>Step 1</h6>
                    <fieldset>
                      <div className="row">
                        <div className="col-xl-4 col-md-6 col-sm-12">
                          <div className="card collapse-icon accordion-icon-rotate">
                            <div className="card-header">
                              <h4 className="card-title">Karachi Vehicles</h4>
                              <a className="heading-elements-toggle"><i className="fa fa-ellipsis-v font-medium-3" /></a>
                              <div className="heading-elements">
                                <ul className="list-inline mb-0">
                                  <li><a data-action="close"><i className="feather icon-x" /></a></li>
                                </ul>
                              </div>
                            </div>
                            <div className="card-content collapse show">
                              <div className="card-body">
                                <div className="accordion" id="accordionExample">
                                  <div className="collapse-margin">
                                    <div className="card-header" id="headingEleven" data-toggle="collapse" role="button" data-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
                                      <div className="col-sm-12">
                                        <span className="lead collapse-title">
                                          <fieldset>
                                            <div className="vs-radio-con vs-radio-warning">
                                              <input type="radio" name="radiocolor" defaultValue="false" />
                                              <span className="vs-radio">
                                                <span className="vs-radio--border" />
                                                <span className="vs-radio--circle" />
                                              </span>
                                              <span className>VRN Number</span>
                                            </div>
                                          </fieldset>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="collapseEleven" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingFive" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSix" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSeven" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion" id="accordionExample">
                                  <div className="collapse-margin">
                                    <div className="card-header" id="headingTwelve" data-toggle="collapse" role="button" data-target="#collapseTwelve" aria-expanded="false" aria-controls="collapseTwelve">
                                      <div className="col-sm-12">
                                        <span className="lead collapse-title">
                                          <fieldset>
                                            <div className="vs-radio-con vs-radio-warning">
                                              <input type="radio" name="radiocolor" defaultValue="false" />
                                              <span className="vs-radio">
                                                <span className="vs-radio--border" />
                                                <span className="vs-radio--circle" />
                                              </span>
                                              <span className>VRN Numver</span>
                                            </div>
                                          </fieldset>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="collapseTwelve" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingFive" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSix" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSeven" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion" id="accordionExample">
                                  <div className="collapse-margin">
                                    <div className="card-header" id="headingThirteen" data-toggle="collapse" role="button" data-target="#collapseThirteen" aria-expanded="false" aria-controls="collapseThirteen">
                                      <div className="col-sm-12">
                                        <span className="lead collapse-title">
                                          <fieldset>
                                            <div className="vs-radio-con vs-radio-warning">
                                              <input type="radio" name="radiocolor" defaultValue="false" />
                                              <span className="vs-radio">
                                                <span className="vs-radio--border" />
                                                <span className="vs-radio--circle" />
                                              </span>
                                              <span className>VRN Numver</span>
                                            </div>
                                          </fieldset>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="collapseThirteen" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingFive" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSix" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSeven" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion" id="accordionExample">
                                  <div className="collapse-margin">
                                    <div className="card-header" id="headingFourteen" data-toggle="collapse" role="button" data-target="#collapseFourteen" aria-expanded="false" aria-controls="collapseFourteen">
                                      <div className="col-sm-12">
                                        <span className="lead collapse-title">
                                          <fieldset>
                                            <div className="vs-radio-con vs-radio-warning">
                                              <input type="radio" name="radiocolor" defaultValue="false" />
                                              <span className="vs-radio">
                                                <span className="vs-radio--border" />
                                                <span className="vs-radio--circle" />
                                              </span>
                                              <span className>VRN Numver</span>
                                            </div>
                                          </fieldset>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="collapseFourteen" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingFive" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSix" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSeven" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-sm-12">
                          <div className="card collapse-icon accordion-icon-rotate">
                            <div className="card-header">
                              <h4 className="card-title">Lahore Vehicles</h4>
                              <a className="heading-elements-toggle"><i className="fa fa-ellipsis-v font-medium-3" /></a>
                              <div className="heading-elements">
                                <ul className="list-inline mb-0">
                                  <li><a data-action="close"><i className="feather icon-x" /></a></li>
                                </ul>
                              </div>
                            </div>
                            <div className="card-content collapse show">
                              <div className="card-body">
                                <div className="accordion" id="accordionExample">
                                  <div className="collapse-margin">
                                    <div className="card-header" id="headingFifteen" data-toggle="collapse" role="button" data-target="#collapseFifteen" aria-expanded="false" aria-controls="collapseFifteen">
                                      <div className="col-sm-12">
                                        <span className="lead collapse-title">
                                          <fieldset>
                                            <div className="vs-radio-con vs-radio-warning">
                                              <input type="radio" name="radiocolor" defaultValue="false" />
                                              <span className="vs-radio">
                                                <span className="vs-radio--border" />
                                                <span className="vs-radio--circle" />
                                              </span>
                                              <span className>VRN Numver</span>
                                            </div>
                                          </fieldset>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="collapseFifteen" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingFive" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSix" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSeven" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion" id="accordionExample">
                                  <div className="collapse-margin">
                                    <div className="card-header" id="headingSixteen" data-toggle="collapse" role="button" data-target="#collapseSixteen" aria-expanded="false" aria-controls="collapseSixteen">
                                      <div className="col-sm-12">
                                        <span className="lead collapse-title">
                                          <fieldset>
                                            <div className="vs-radio-con vs-radio-warning">
                                              <input type="radio" name="radiocolor" defaultValue="false" />
                                              <span className="vs-radio">
                                                <span className="vs-radio--border" />
                                                <span className="vs-radio--circle" />
                                              </span>
                                              <span className>VRN Numver</span>
                                            </div>
                                          </fieldset>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="collapseSixteen" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingFive" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSix" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSeven" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion" id="accordionExample">
                                  <div className="collapse-margin">
                                    <div className="card-header" id="headingSeventeen" data-toggle="collapse" role="button" data-target="#collapseSeventeen" aria-expanded="false" aria-controls="collapseSeventeen">
                                      <div className="col-sm-12">
                                        <span className="lead collapse-title">
                                          <fieldset>
                                            <div className="vs-radio-con vs-radio-warning">
                                              <input type="radio" name="radiocolor" defaultValue="false" />
                                              <span className="vs-radio">
                                                <span className="vs-radio--border" />
                                                <span className="vs-radio--circle" />
                                              </span>
                                              <span className>VRN Numver</span>
                                            </div>
                                          </fieldset>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="collapseSeventeen" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingFive" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSix" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSeven" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion" id="accordionExample">
                                  <div className="collapse-margin">
                                    <div className="card-header" id="headingEighteen" data-toggle="collapse" role="button" data-target="#collapseEighteen" aria-expanded="false" aria-controls="collapseEighteen">
                                      <div className="col-sm-12">
                                        <span className="lead collapse-title">
                                          <fieldset>
                                            <div className="vs-radio-con vs-radio-warning">
                                              <input type="radio" name="radiocolor" defaultValue="false" />
                                              <span className="vs-radio">
                                                <span className="vs-radio--border" />
                                                <span className="vs-radio--circle" />
                                              </span>
                                              <span className>VRN Numver</span>
                                            </div>
                                          </fieldset>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="collapseEighteen" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingFive" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSix" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSeven" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-sm-12">
                          <div className="card collapse-icon accordion-icon-rotate">
                            <div className="card-header">
                              <h4 className="card-title">Islamabad</h4>
                              <a className="heading-elements-toggle"><i className="fa fa-ellipsis-v font-medium-3" /></a>
                              <div className="heading-elements">
                                <ul className="list-inline mb-0">
                                  <li><a data-action="close"><i className="feather icon-x" /></a></li>
                                </ul>
                              </div>
                            </div>
                            <div className="card-content collapse show">
                              <div className="card-body">
                                <div className="accordion" id="accordionExample">
                                  <div className="collapse-margin">
                                    <div className="card-header" id="headingNineteen" data-toggle="collapse" role="button" data-target="#collapseNineteen" aria-expanded="false" aria-controls="collapseNineteen">
                                      <div className="col-sm-12">
                                        <span className="lead collapse-title">
                                          <fieldset>
                                            <div className="vs-radio-con vs-radio-warning">
                                              <input type="radio" name="radiocolor" defaultValue="false" />
                                              <span className="vs-radio">
                                                <span className="vs-radio--border" />
                                                <span className="vs-radio--circle" />
                                              </span>
                                              <span className>VRN Numver</span>
                                            </div>
                                          </fieldset>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="collapseNineteen" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingFive" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSix" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSeven" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion" id="accordionExample">
                                  <div className="collapse-margin">
                                    <div className="card-header" id="headingTwenty" data-toggle="collapse" role="button" data-target="#collapseTwenty" aria-expanded="false" aria-controls="collapseTwenty">
                                      <div className="col-sm-12">
                                        <span className="lead collapse-title">
                                          <fieldset>
                                            <div className="vs-radio-con vs-radio-warning">
                                              <input type="radio" name="radiocolor" defaultValue="false" />
                                              <span className="vs-radio">
                                                <span className="vs-radio--border" />
                                                <span className="vs-radio--circle" />
                                              </span>
                                              <span className>VRN Numver</span>
                                            </div>
                                          </fieldset>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="collapseTwenty" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingFive" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSix" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSeven" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion" id="accordionExample">
                                  <div className="collapse-margin">
                                    <div className="card-header" id="headingTwentyone" data-toggle="collapse" role="button" data-target="#collapseTwentyone" aria-expanded="false" aria-controls="collapseTwentyone">
                                      <div className="col-sm-12">
                                        <span className="lead collapse-title">
                                          <fieldset>
                                            <div className="vs-radio-con vs-radio-warning">
                                              <input type="radio" name="radiocolor" defaultValue="false" />
                                              <span className="vs-radio">
                                                <span className="vs-radio--border" />
                                                <span className="vs-radio--circle" />
                                              </span>
                                              <span className>VRN Numver</span>
                                            </div>
                                          </fieldset>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="collapseTwentyone" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingFive" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSix" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSeven" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion" id="accordionExample">
                                  <div className="collapse-margin">
                                    <div className="card-header" id="headingTwentytwo" data-toggle="collapse" role="button" data-target="#collapseTwentytwo" aria-expanded="false" aria-controls="collapseTwentytwo">
                                      <div className="col-sm-12">
                                        <span className="lead collapse-title">
                                          <fieldset>
                                            <div className="vs-radio-con vs-radio-warning">
                                              <input type="radio" name="radiocolor" defaultValue="false" />
                                              <span className="vs-radio">
                                                <span className="vs-radio--border" />
                                                <span className="vs-radio--circle" />
                                              </span>
                                              <span className>VRN Numver</span>
                                            </div>
                                          </fieldset>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="collapseTwentytwo" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingFive" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSix" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{padding: '0px 14px 5px 14px !important'}}>
                                        <div className="collapse-margin" style={{marginBottom: '0px !important'}}>
                                          <div className="card-header" id="headingSeven" data-toggle="collapse" role="button" aria-expanded="false">
                                            <div className="col-sm-12">
                                              <span className="lead collapse-title">
                                                7002 1231 2587 0000
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                    {/* Step 2 */}
                    <h6 style={{color: '#000'}}>Step 2</h6>
                    <fieldset>
                      <div className="row">
                        <div className="col-sm-12">
                          <h4 className="mb-1">Driver Schedule</h4>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <p>Please fill this form to set your driver schedule</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label htmlFor="firstName1">Driver Name</label>
                            <input type="text" className="form-control" id="firstName1" />
                          </div>
                        </div>
                        <div className="col-sm-6 col-12">
                          <div className="form-group">
                            <label htmlFor="firstName1">Select Days</label>
                            <select className="select2 form-control" multiple="multiple">
                              <option value="square">Monday</option>
                              <option value="rectangle" selected>Tuesday</option>
                              <option value="rombo">Wednesday</option>
                              <option value="romboid">Thursday</option>
                              <option value="trapeze">Friday</option>
                              <option value="traible" selected>Saturday</option>
                              <option value="polygon">Sunday</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6 col-12 mb-1">
                          <label htmlFor="firstName1">Select Start Time</label>
                          <input type="text" className="form-control pickatime-min-max" />
                        </div>
                        <div className="col-md-6 col-12 mb-1">
                          <form>
                            <label htmlFor="firstName2">Select End Time</label>
                            <input type="text" className="form-control pickatime-min-max" />
                          </form>
                        </div>
                      </div>
                    </fieldset></form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

            </Container>

        );

    }

}


export default ManageDriverSchedule;
